module.exports = __webpack_public_path__ + "static/media/1.c41a5600.png";